import { Box, CircularProgress, Container, Grid, Modal, Paper, Table, TableBody, TableCell, TableHead, TableRow, styled, tableCellClasses } from '@mui/material'
import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

class FuncionariosJefes extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            loading: false,
            consultaRealizada: false,
            numeroNombre: [],
            datosConsulta: [],

            busqueda: {
                numeroFuncionario: '',
                nombreFuncionario: '',
            },

            consulta: {
                numeroFuncionario: '',
            },

            datoEspecifico: {},
            modalBorrar: false,
        }

        this.manejoEnvioAlta = this.manejoEnvioAlta.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarCambiosDatosNum = this.manejarCambiosDatosNum.bind(this);
        this.manejarBorrar = this.manejarBorrar.bind(this);
        this.manejarCerrarModal = this.manejarCerrarModal.bind(this);
        this.manejarEnvioBaja = this.manejarEnvioBaja.bind(this);
        this.actualizarLista = this.actualizarLista.bind(this);
        this.manejoVolver = this.manejoVolver.bind(this);
    }
    async componentDidMount(){

        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });
    }
    render(){
        return (
            <>
                <Container style={{backgroundColor: '#F2F3F4'}}>
                    <h3>Funcionarios Jefes</h3>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    {this.state.consultaRealizada
                    ?
                        null
                    :
                        <form className='formulario1'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>Número de Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.consulta.numeroFuncionario} onChange={this.manejarCambiosDatosNum} type="text" />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    }
                    {this.state.consultaRealizada
                    ?
                        null
                    :
                        <Container style={{backgroundColor: '#F2F3F4'}}>
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Número</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroFuncionario' value={this.state.busqueda.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell>{this.state.busqueda.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioAlta()}>Confirmar</button></StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </Container>
                    }
                    {this.state.consultaRealizada
                    ?
                        <Container>
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Número</StyledTableCell>
                                        <StyledTableCell>Nombre</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {this.state.datosConsulta.map((name) => (
                                    <StyledTableRow key={name.idFuncionariosJefes}>
                                        <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarBorrar(name)}>Borrar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                                </TableBody>
                            </Table>
                            <button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejoVolver()}>Volver</button>
                        </Container>
                    :
                        null
                    }
                </Container>
                <Modal open={this.state.modalBorrar}>
                    <Box sx={styleModal} >
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item xs={3.5}>
                            </Grid>
                            <Grid item xs={5}>
                                ¿Eliminar Funcionario?
                            </Grid>
                            <Grid item xs={3.5}>
                            </Grid>
                            <Grid item xs={3.5}>
                            </Grid>
                            <Grid item xs={2}>
                                <button className="btn btn-outline-success mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarCerrarModal}>Cerrar</button>
                            </Grid>
                            <Grid item xs={2}>
                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBaja}>Confirmar</button>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>
            </>
        )
    }


    async actualizarLista(e){
        this.setState({
            errores: null,
            loading: true,
        });
        const cargaUtil = JSON.stringify([this.state.consulta]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_FuncionariosJefes.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
            loading: false,
        })

        if(exito[0] === 'ok'){
            this.setState({
                loading: false,
                errores: null,
                datosConsulta: exito[1],
                consultaRealizada: true,
            })
        }
    }

    async manejoEnvioAlta(){

        if(this.state.busqueda.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario',
            })
        }else if((this.state.busqueda.numeroFuncionario !== '') && (this.state.busqueda.nombreFuncionario === '')){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido',
            })
        }else{
            this.setState({
                errores: null,
                loading: true,
                notificaciones: null,
            });

            const cargaUtil = JSON.stringify([this.state.busqueda]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/agregar_funcionarioJefe.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                errores: exito[0],
                loading: false,
            })

            if(exito[0] === 'ok'){
                this.setState({
                    errores: null,
                    loading: false,
                    notificaciones: 'Datos ingresados correctamente',
                    busqueda: {
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                    },
                })
            }
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movimientosActualizado = state.busqueda;
            if(clave === 'numeroFuncionario'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    movimientosActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    movimientosActualizado['nombreFuncionario'] = '';
                }
                });
            }
            movimientosActualizado[clave] = valor;
            return{
                busqueda: movimientosActualizado,
            };
        })
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        this.setState({
            errores: null,
            loading: true,
            notificaciones: null,
        });

        const cargaUtil = JSON.stringify([this.state.consulta]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_FuncionariosJefes.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
            loading: false,
        })

        if(exito[0] === 'ok'){
            this.setState({
                loading: false,
                errores: null,
                notificaciones: null,
                datosConsulta: exito[1],
                consultaRealizada: true,
            })
        }
    }

    manejarCambiosDatosNum(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movimientosActualizado = state.consulta;
            movimientosActualizado[clave] = valor;
            return{
                consulta: movimientosActualizado,
            };
        })
    }

    manejarBorrar(dato){
        this.setState({
            datoEspecifico: dato,
            modalBorrar: true,
        })
    }

    manejarCerrarModal(e){
        e.preventDefault();
        this.setState({
            modalBorrar: false,
            datoEspecifico: {},
        })
    }

    async manejarEnvioBaja(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        })
        const cargaUtil = JSON.stringify([this.state.datoEspecifico]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_funcionarioJefe.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
            loading: false,
        })

        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Eliminado correctamente',
                datoEspecifico: {},
                modalBorrar: false,
            })
            this.actualizarLista();
        }
    }

    manejoVolver(){
        this.setState({
            modalBorrar: false,
            datoEspecifico: {},
            datosConsulta: [],
            consultaRealizada: false,
        })
    }
}

export default FuncionariosJefes